module.exports = __webpack_public_path__ + "img/name.a874fac3.png";